import AuthStore from '@stores/AuthStore';
import createPromiseFactory from './factory';
import queryParser from './queryParser';

const Axios = {
  Get: ({ url, params, cache = false }) => {
    return createPromiseFactory({
      cache,
      timeout: 15000,
      url: url + queryParser(params),
      method: 'GET',
      headers: {
        Authorization: AuthStore.idToken,
      },
    });
  },
  GetWithAuth: async ({ url, params, cache = false }) => {
    await AuthStore.getIdToken();
    return createPromiseFactory({
      cache,
      timeout: 15000,
      url: url + queryParser(params),
      method: 'GET',
      headers: {
        Authorization: AuthStore.idToken,
      },
    });
  },
  Post: async ({ url, data }) => {
    await AuthStore.getIdToken();
    return createPromiseFactory({
      url,
      method: 'post',
      data,
      headers: {
        Authorization: AuthStore.idToken,
      },
    });
  },
  Put: ({ url, params, data }) => {
    return createPromiseFactory({
      url: url + queryParser(params),
      method: 'put',
      data,
    });
  },
  Patch: ({ url, params, data }) => {
    return createPromiseFactory({
      url: url + queryParser(params),
      method: 'patch',
      data,
    });
  },
  Delete: ({ url, params }) => {
    return createPromiseFactory({
      url: url + queryParser(params),
      method: 'delete',
    });
  },
  PostWithoutAuth: ({ url, data }) => {
    return createPromiseFactory({
      url,
      method: 'post',
      data,
    });
  },
};

export default Axios;
